import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';

import { getErrorMessage } from '../../../utils/serverErrorCheck';
import {
  EventsControllerDtoEventRaffleHistoryListRequest, EventsControllerDtoEventRaffleHistoryListResponse,
  EventsControllerDtoRaffleInfoRequest, EventsControllerDtoRaffleInfoResponse,
  EventsControllerDtoRaffleListRequest,
  EventsControllerDtoRaffleListResponse, EventsControllerDtoRaffleUpsertRequest,
  PerplayEventsApi
} from "../../models/src";
import {
  RAFFLE_EVENT_HISTORY_LIST_REQUEST,
  RAFFLE_EVENT_INFO_REQUEST,
  RAFFLE_EVENT_LIST_REQUEST,
  RAFFLE_EVENT_UPSERT_REQUEST
} from "../../constants/event/raffleEventConstants";

const api = new PerplayEventsApi(config.API_CLIENT);

function* raffleListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoRaffleListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventRaffleListPost({ eventsControllerDtoRaffleListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoRaffleListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* raffleUpsertRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoRaffleUpsertRequest();
    requestData.raffleNo = payload.raffleNo;
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    requestData.itemDrawStartAt = payload.itemDrawStartAt;
    requestData.itemDrawEndAt = payload.itemDrawEndAt;
    requestData.ticketRequiredCount = payload.ticketRequiredCount;
    requestData.ticketItems = payload.ticketItems;
    requestData.jsonRoundInfo = payload.jsonRoundInfo;
    requestData.jsonRewardInfo = payload.jsonRewardInfo;
    requestData.jsonBonusReward = payload.jsonBonusReward;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventRaffleUpsertPost({ eventsControllerDtoRaffleUpsertRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* raffleInfoRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoRaffleInfoRequest();
    requestData.raffleNo = payload.raffleNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventRaffleInfoPost({ eventsControllerDtoRaffleInfoRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoRaffleInfoResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* raffleHistoryRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventRaffleHistoryListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.raffleNo = payload.raffleNo;
    requestData.accountNo = payload.accountNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventRaffleHistoryListPost({ eventsControllerDtoEventRaffleHistoryListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventRaffleHistoryListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}



function* raffleRootSaga() {
  yield all([
    takeEvery(RAFFLE_EVENT_LIST_REQUEST, raffleListRequestSaga),
    takeEvery(RAFFLE_EVENT_UPSERT_REQUEST, raffleUpsertRequestSaga),
    takeEvery(RAFFLE_EVENT_INFO_REQUEST, raffleInfoRequestSaga),
    takeEvery(RAFFLE_EVENT_HISTORY_LIST_REQUEST, raffleHistoryRequestSaga),
  ]);
}

const raffleSagas = [
  fork(raffleRootSaga)
];

export default raffleSagas;
